var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDictionary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9998 23.1429H5.45452C4.80354 23.1429 4.17922 22.872 3.71891 22.3897C3.2586 21.9075 3 21.2534 3 20.5715C3 19.8895 3.2586 19.2354 3.71891 18.7532C4.17922 18.271 4.80354 18 5.45452 18H19.3634M19.3634 18C19.7974 18 20.2136 17.8194 20.5205 17.4979C20.8274 17.1764 20.9998 16.7404 20.9998 16.2857V2.57146C20.9998 2.11681 20.8274 1.68077 20.5205 1.35928C20.2136 1.03779 19.7974 0.857178 19.3634 0.857178H5.45452C4.81472 0.85694 4.20012 1.11842 3.74165 1.58593C3.28317 2.05343 3.01706 2.69 3 3.36004V20.5029M19.3634 18V23.1429",
    stroke: "#C6CBD9",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7194 8.57484H17.5091L13.4837 14.5286H17.7448M6.29199 10.2617L8.03634 4.7777C8.0799 4.641 8.16338 4.52211 8.27496 4.43782C8.38654 4.35353 8.52058 4.30811 8.65815 4.30798C8.94123 4.30798 9.19323 4.49655 9.28323 4.7777L11.0276 10.2617M6.92362 8.27655H10.3959",
    stroke: "#C6CBD9",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDictionary);
export default __webpack_public_path__ + "static/media/Dictionary.17bf8ae0f52e8ad4a3d348ff679cb0e9.svg";
export { ForwardRef as ReactComponent };